module.exports = __webpack_public_path__ + "static/Cloud Agronomics-be3db3f73f875d903e429810dcd336a1.jpg";